export enum Permission{
    DASHBOARD = "Dashboard",
    MEASURE = "Measure",
    INFOS = "Infos",
    DESCRIPTION = "Description",
    MILESTONES = "MileStones",
    TASKS="Tasks",
    CREATE_APPROVAL_REQUEST = "CreateApprovalRequest",
    APPROVAL_REQUEST_STEP1 = "ApprovalRequestStep1",
    APPROVAL_REQUEST_STEP2 = "ApprovalRequestStep2",
    CHANGE_HARTEGRAD = "ChangeHartegrad",
    STATUS_REPORT = "StatusReport",
    RATING_UPDATE = "RatingUpdate",
    SUBPROJECT = "Subproject",
    PROJECT = "Project",
    ROLES = "Roles",
    PROJECT_SELECTION = "ProjectSelection",
    COMPANIES = "Companies",
    DOCUMENTS = "Documents",
    STAFF_MEMBERS = "Staff-Members",
    TRAINING_CENTER = "Traning-center",
    GANTT = "Gantt",
    REPORT = "Report",
    ROLE_RIGHTS = "roleRights"
}
export enum Actions{
    VIEW = 'CanView',
    UPDATE = 'CanUpdate',
    CREATE = 'CanCreate',
    DELETE = 'CanDelete',
}